module.exports = __webpack_public_path__ + "static/media/expandarrow.55add55a.svg";